export const ImportFileOptions = {
    PAYOUT: {
      CONFIG: 'payout_services.configuration',
      PROCESS: 'payout_process',
      SKIP_PATH: '/payout_process/list',
      IMPORT_FILE_PATH: '../../assets/helpfiles/payout-import'
    },
    PAYMENT: {
      CONFIG: 'payment_process_services.configuration',
      PROCESS: 'payment_process',
      SKIP_PATH: '/processes/batches',
      IMPORT_FILE_PATH: '../../assets/helpfiles/payment-import'
    }
}

export enum ImportOptions {
  PAYMENTS = 'PAYMENT',
  PAYOUT = 'PAYOUT'
}
